import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col pt-8" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "uppercase text-gray-400" }, "Suggested actions"),
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-gray-300 mx-4" }),
  /*#__PURE__*/_createElementVNode("button", { class: "text-gray-400" }, "Don't show again")
], -1)
const _hoisted_3 = { class: "flex flex-col lg:flex-row lg:space-x-5 mt-6 space-y-3 lg:space-y-0" }
const _hoisted_4 = { class: "flex flex-row bg-white p-4 rounded-lg justify-between items-center shadow w-full" }
const _hoisted_5 = { class: "flex flex-col p-2 w-full" }
const _hoisted_6 = { class: "flex flex-row justify-between items-center w-full" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "text-lg font-semibold" }, "Create a job", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-4 w-4 mr-3",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "3",
    d: "M12 4v16m8-8H4"
  })
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm" }, "New job", -1)
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { class: "flex flex-row bg-white p-4 rounded-lg w-full justify-between items-center shadow" }
const _hoisted_12 = { class: "flex flex-col p-2 w-full" }
const _hoisted_13 = { class: "flex flex-row w-full justify-between items-center" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "text-lg font-semibold" }, "Axelerate Help Center", -1)
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<svg class=\"h-6 w-6 mr-3\" viewBox=\"0 0 22 22\" fill=\"none\"><circle cx=\"11.0007\" cy=\"10.9997\" r=\"9.16667\" stroke=\"#f36f2a\" stroke-width=\"2\"></circle><path d=\"M11 12.667V12.3132C11 11.3201 11.7851 10.5168 12.5842 9.92715C13.1714 9.49394 13.6606 8.79105 13.5 7.66699C13.1429 5.16697 9.75 6.41699 9.75 6.41699\" stroke=\"#f36f2a\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M11 15.167V15.5837\" stroke=\"#f36f2a\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg><span class=\"text-sm\">Get support</span>", 2)
const _hoisted_17 = [
  _hoisted_15
]
const _hoisted_18 = { class: "flex flex-row bg-white p-4 rounded-lg justify-between items-center shadow w-full" }
const _hoisted_19 = { class: "flex flex-col p-2 w-full" }
const _hoisted_20 = { class: "flex flex-row w-full justify-between items-center" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "text-lg font-semibold" }, " Company Job board", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-6 w-6 mr-3",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z"
  })
], -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm" }, "Share", -1)
const _hoisted_24 = [
  _hoisted_22,
  _hoisted_23
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalUpgradePlan = _resolveComponent("ModalUpgradePlan")!
  const _component_ReusableModal = _resolveComponent("ReusableModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", {
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addNewJob && _ctx.addNewJob(...args))),
                class: "flex flex-row justify-end bg-blue-50 py-2 px-4 items-center text-blue-600 rounded-lg font-medium cursor-pointer"
              }, _hoisted_10)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("div", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.sendToHelpCenter())),
                class: "flex justify-end bg-orange-50 py-2 px-4 items-center text-orange-600 rounded-lg font-medium cursor-pointer"
              }, _hoisted_17)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("div", {
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.editProfile && _ctx.editProfile(...args))),
                class: "flex justify-end bg-green-50 py-2 px-4 items-center text-green-600 rounded-lg font-medium cursor-pointer"
              }, _hoisted_24)
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_ReusableModal, {
      show: _ctx.showModalUpgrade,
      onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showModalUpgrade = false)),
      size: "lg:w-1/3 md:w-9/12 w-11/12"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ModalUpgradePlan, {
          onCloseModal: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showModalUpgrade = false))
        })
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}